module.exports = __webpack_public_path__ + "static/media/vet.60f739fd.png";